import { useSignal, $, useTask$, useOnDocument } from "@builder.io/qwik";
import { isBrowser } from "@builder.io/qwik/build";
function usePopover(customId) {
  const hasPolyfillLoadedSig = useSignal(false);
  const isSupportedSig = useSignal(false);
  const didInteractSig = useSignal(false);
  const programmaticRef = useSignal(null);
  const isCSRSig = useSignal(false);
  const loadPolyfill$ = $(async () => {
    document.dispatchEvent(new CustomEvent("poppolyload"));
  });
  useTask$(() => {
    if (isBrowser) {
      isCSRSig.value = true;
    }
  });
  const initPopover$ = $(async () => {
    const isSupported = typeof HTMLElement !== "undefined" && typeof HTMLElement.prototype === "object" && "popover" in HTMLElement.prototype;
    isSupportedSig.value = isSupported;
    if (!hasPolyfillLoadedSig.value && !isSupported) {
      await loadPolyfill$();
    }
    if (!didInteractSig.value) {
      if (programmaticRef.value === null) {
        programmaticRef.value = document.getElementById(`${customId}-panel`);
      }
      didInteractSig.value = true;
    }
    return programmaticRef.value;
  });
  useOnDocument("showpopoverpoly", $(async () => {
    if (!didInteractSig.value)
      return;
    await import("@oddbird/popover-polyfill");
    hasPolyfillLoadedSig.value = true;
  }));
  const showPopover = $(async () => {
    await initPopover$();
    if (!isSupportedSig.value) {
      while (!hasPolyfillLoadedSig.value) {
        await new Promise((resolve) => setTimeout(resolve, 10));
      }
    }
    programmaticRef.value?.showPopover();
  });
  const togglePopover = $(async () => {
    await initPopover$();
    if (!isSupportedSig.value) {
      while (!hasPolyfillLoadedSig.value) {
        await new Promise((resolve) => setTimeout(resolve, 10));
      }
    }
    programmaticRef.value?.togglePopover();
  });
  const hidePopover = $(async () => {
    await initPopover$();
    if (!isSupportedSig.value) {
      while (!hasPolyfillLoadedSig.value) {
        await new Promise((resolve) => setTimeout(resolve, 10));
      }
    }
    programmaticRef.value?.hidePopover();
  });
  return {
    showPopover,
    togglePopover,
    hidePopover,
    initPopover$,
    hasPolyfillLoadedSig,
    isSupportedSig
  };
}
export {
  usePopover
};
